import { makeStyles } from 'tss-react/mui';
import React from 'react';
import palette from '@ui/palette';
import Typography from '@ui/Typography';
import LegacyButton from '@ui/Button/legacy/Button/Button';

interface CommentsFailedErrorProps {
  onRefresh: () => void;
}

const CommentsFailedError = (props: CommentsFailedErrorProps) => {
  const { onRefresh } = props;
  const { classes } = useStyles();
  return (
    <div className={classes.errorContainer}>
      <div className={classes.errorSubcontainer}>
        <div className={classes.errorTextContainer}>
          <Typography variant="h5" bold component="h4">
            Comments failed to load
          </Typography>
          <Typography variant="pMd" component="p">
            Click refresh to try again.
          </Typography>
        </div>
        <LegacyButton
          aria-label="Refresh comments list"
          onClick={onRefresh}
          className={classes.refreshButton}
        >
          <Typography variant="h4" bold>
            Refresh
          </Typography>
        </LegacyButton>
      </div>
    </div>
  );
};

const useStyles = makeStyles()(theme => ({
  errorContainer: {
    height: '100%',
    borderTop: `1px solid ${palette.gray_800}`,
  },
  errorSubcontainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    alignItems: 'center',
    justifyContent: 'center',
  },
  errorTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  refreshButton: {
    width: 'fit-content',
    padding: '8px 24px',
  },
}));

export default CommentsFailedError;
